// TODO доделать нормальную локализацию

export const resources = {
  kz: {
    translation: {
      'Валютный платеж': 'Шетел валютасымен төлеу',
      'Счёт списания': 'Счёт списания',
      Контракт: 'Контракт',
      Сумма: 'Сумма',
      'Дата валютирования': 'Дата валютирования',
      КНП: 'КНП',
      'Назначение платежа': 'Назначение платежа',
      moneyTransferCondition:
        'Данный перевод денег не связан с исполнением валютного договора, по которому требуется присвоение учетного номера.',
      'Счёт списания комиссии': 'Счёт списания комиссии',
      Подпись: 'Подпись',
      'Главный бухгалтер': 'Главный бухгалтер',
      Контакты: 'Контакты',
      'Очистить поля': 'Очистить поля',
      'Обязательное поле для заполнения': 'Обязательное поле для заполнения',
      'Необходимо заполнить': 'Необходимо заполнить',
      Комиссия: 'Комиссия',
      Получатель: 'Получатель',
      'Счёт получателя': 'Счёт получателя',
      Страна: 'Страна',
      Кбе: 'Кбе',
      Адрес: 'Адрес',
      'Банк получателя': 'Банк получателя',
      БИК: 'БИК',
      'Счёт банка': 'Счёт банка',
      'Банк получатель': 'Банк получатель',
      'Дата контракта': 'Дата контракта',
      Цель: 'Цель',
      purposeInfo:
        'Поля “Контракт”, “Дата создания контракта” и “Цель” должны в сумме содержать не более 140 символов',
      'Информация для получателя': 'Информация для получателя',
      'Пример: 711 или 221': 'Пример: 711 или 221',
      confirmationInfo: 'Перевод на сумму до 10 000 $ не требует предоставления контракта в Банк',
      counterpartyInfo: 'Введите наименование',
      counterparty: 'Контрагент',
      swiftInfo:
        'По Международному формату Swift на поля “Наименование получателя”, “Страна” и “Адрес” должны в сумме содержать не более 140 символов',
      'Код VO': 'Код VO',
      swiftInfoTwo:
        'Поля “Номер контракта”, “Дата контракта” и “Цель” должны в сумме содержать не более 140 символов',
    },
  },
  ru: {
    translation: {
      'Валютный платеж': 'Валютный платеж',
      'Счёт списания': 'Счёт списания',
      Контракт: 'Контракт',
      Сумма: 'Сумма',
      'Дата валютирования': 'Дата валютирования',
      КНП: 'КНП',
      'Назначение платежа': 'Назначение платежа',
      moneyTransferCondition:
        'Данный перевод денег не связан с исполнением валютного договора, по которому требуется присвоение учетного номера.',
      'Счёт списания комиссии': 'Счёт списания комиссии',
      Подпись: 'Подпись',
      'Главный бухгалтер': 'Главный бухгалтер',
      Контакты: 'Контакты',
      'Очистить поля': 'Очистить поля',
      'Обязательное поле для заполнения': 'Обязательное поле для заполнения',
      'Необходимо заполнить': 'Необходимо заполнить',
      Комиссия: 'Комиссия',
      Получатель: 'Получатель',
      'Счёт получателя': 'Счёт получателя',
      Страна: 'Страна',
      Кбе: 'Кбе',
      Адрес: 'Адрес',
      'Банк получателя': 'Банк получателя',
      БИК: 'БИК',
      'Счёт банка': 'Счёт банка',
      'Банк получатель': 'Банк получатель',
      'Дата контракта': 'Дата контракта',
      Цель: 'Цель',
      purposeInfo:
        'Поля “Контракт”, “Дата создания контракта” и “Цель” должны в сумме содержать не более 140 символов',
      'Информация для получателя': 'Информация для получателя',
      'Пример: 711 или 221': 'Пример: 711 или 221',
      confirmationInfo: 'Перевод на сумму до 10 000 $ не требует предоставления контракта в Банк',
      counterpartyInfo: 'Введите наименование',
      counterparty: 'Контрагент',
      swiftInfo:
        'По Международному формату Swift на поля “Наименование получателя”, “Страна” и “Адрес” должны в сумме содержать не более 140 символов',
      'Код VO': 'Код VO',
      swiftInfoTwo:
        'Поля “Номер контракта”, “Дата контракта” и “Цель” должны в сумме содержать не более 140 символов',
    },
  },
  en: {
    translation: {
      'Валютный платеж': 'Currency payment',
      'Счёт списания': 'Счёт списания',
      Контракт: 'Контракт',
      Сумма: 'Сумма',
      'Дата валютирования': 'Дата валютирования',
      КНП: 'КНП',
      'Назначение платежа': 'Назначение платежа',
      moneyTransferCondition:
        'Данный перевод денег не связан с исполнением валютного договора, по которому требуется присвоение учетного номера.',
      'Счёт списания комиссии': 'Счёт списания комиссии',
      Подпись: 'Подпись',
      'Главный бухгалтер': 'Главный бухгалтер',
      Контакты: 'Контакты',
      'Очистить поля': 'Очистить поля',
      'Обязательное поле для заполнения': 'Обязательное поле для заполнения',
      'Необходимо заполнить': 'Необходимо заполнить',
      Комиссия: 'Комиссия',
      Получатель: 'Получатель',
      'Счёт получателя': 'Счёт получателя',
      Страна: 'Страна',
      Кбе: 'Кбе',
      Адрес: 'Адрес',
      'Банк получателя': 'Банк получателя',
      БИК: 'БИК',
      'Счёт банка': 'Счёт банка',
      'Банк получатель': 'Банк получатель',
      'Дата контракта': 'Дата контракта',
      Цель: 'Цель',
      purposeInfo:
        'Поля “Контракт”, “Дата создания контракта” и “Цель” должны в сумме содержать не более 140 символов',
      'Информация для получателя': 'Информация для получателя',
      'Пример: 711 или 221': 'Пример: 711 или 221',
      confirmationInfo: 'Перевод на сумму до 10 000 $ не требует предоставления контракта в Банк',
      counterpartyInfo: 'Введите наименование',
      counterparty: 'Контрагент',
      swiftInfo:
        'По Международному формату Swift на поля “Наименование получателя”, “Страна” и “Адрес” должны в сумме содержать не более 140 символов',
      'Код VO': 'Код VO',
      swiftInfoTwo:
        'Поля “Номер контракта”, “Дата контракта” и “Цель” должны в сумме содержать не более 140 символов',
    },
  },
};
